/* Plantis — parallax, scroll fades, navigatie en accordions */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------- reveal on enter -- */
  var revealTargets = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));

  if (!('IntersectionObserver' in window) || reduceMotion) {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  }

  /* -------------------------------------------- parallax + scroll fades -- */
  var parallaxLayers = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var fadeLayers = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-fade]'));
  var ticking = false;

  function paint() {
    var vh = window.innerHeight || document.documentElement.clientHeight;

    parallaxLayers.forEach(function (el) {
      var box = el.getBoundingClientRect();
      if (box.bottom < -300 || box.top > vh + 300) return;

      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.18;
      var progress = (box.top + box.height / 2 - vh / 2) / vh;   /* ~ -1 .. 1 */
      var shift = progress * speed * 140;

      el.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
    });

    fadeLayers.forEach(function (el) {
      var box = el.getBoundingClientRect();
      if (box.bottom < -200 || box.top > vh + 200) return;

      var centre = box.top + box.height / 2;
      var distance = Math.abs(centre - vh / 2) / (vh * 0.8);
      var opacity = 1 - Math.pow(Math.min(distance, 1), 2);
      opacity = Math.max(0, Math.min(1, opacity));

      el.style.opacity = opacity.toFixed(3);
      el.style.transform = 'translate3d(0,' + ((1 - opacity) * 30).toFixed(2) + 'px,0)';
    });

    ticking = false;
  }

  function requestPaint() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  if (!reduceMotion && (parallaxLayers.length || fadeLayers.length)) {
    paint();
    window.addEventListener('scroll', requestPaint, { passive: true });
    window.addEventListener('resize', requestPaint);
    window.addEventListener('orientationchange', requestPaint);
  }

  /* --------------------------------------------------- mobiele navigatie -- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');

  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', open ? 'false' : 'true');
      navToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* -------------------------------------------------------- accordeons --- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-accordion-btn]') : null;
    if (!button) return;

    var panel = button.nextElementSibling;
    var open = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.setAttribute('data-open', open ? 'false' : 'true');
  });

  /* ------------------------------------------ variantkeuze op productpag -- */
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      var price = document.querySelector('[data-variant-price]');
      var submit = document.querySelector('[data-add-to-cart]');

      if (price && option.dataset.price) price.textContent = option.dataset.price;

      if (submit) {
        var available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.labelAdd : submit.dataset.labelSold;
      }
    });
  }
})();
